import swal from "sweetalert";
import {CgCopy, CgEye} from "react-icons/cg";
import { useState,useEffect } from "react";
import { collection, doc, getDoc, getDocs, getFirestore, limit, onSnapshot, orderBy, query, Timestamp, where } from "firebase/firestore";


export default function RequestRow(props) {

    var orderData=props.data;

    const db=getFirestore();
    const [userName,setuserName]=useState(".........");
    const [celebName,setcelebName]=useState(".........");

    

    useEffect(async() => {

        const q = await getDoc(doc(db, "users",orderData["user"]));
        const q2 = await getDoc(doc(db, "celebrities",orderData["celebrity"]));
        
        
        setcelebName(q.data()["fullName"]);

        setuserName(q2.data()["fullName"]);



        return () => {
    
        };
    }, []);




    return (
        <tr className="pb-5">
                <td className="w-1/5 pb-2 pt-2">
                    <div className="h-20 flex justify-center items-center">
                        {orderData["amount"]}₵
                    </div>
                </td>

                <td className="w-1/5">
                    <div className="flex text-white h-20 justify-start items-center overflow-hidden">
                        {orderData["message"]}
                    </div>
                </td>

                <td className="w-1/5">
                    <div id="no-scrollbar" className="h-20 text-white flex justify-start items-center p-2 overflow-x-scroll  ">
                        {/* {orderData["from"]} */}
                        {celebName}
                    </div>
                </td>

                <td className="w-1/5">
                    <div id="no-scrollbar" className="h-20 text-white flex justify-center items-center overflow-scroll">
                        {userName}
                    </div>
                </td>

                <td className="w-1/5">
                    <div id="no-scrollbar" className="h-20 text-white flex justify-center items-center overflow-scroll">
                        {orderData["type"]}
                    </div>
                </td>


        

                <td className="w-1/5">
                    <div className="h-20 text-white flex justify-center items-center">
                        {orderData["createdAt"].toDate().getDate().toString()}-{(orderData["createdAt"].toDate().getMonth() + 1).toString()}-{orderData["createdAt"].toDate().getFullYear().toString()}
                    </div>
                </td>

                <td className="w-1/5">
                    <div className="h-20 text-white flex justify-center items-center">
                        {orderData["status"]}
                    </div>
                </td>
                

                <td>
                    <div className="h-20 flex justify-center items-center">
                        <button
                            onClick={() => {
                                props.seeOrderInfo()
                            }}
                            className="hover:scale-105 flex justify-center items-center">
                            <CgEye size={40} color={"black"} className="bg-white p-2 rounded" />
                        </button>
                    </div>
                </td>



            </tr>
    )
}